import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import classnames from "classnames";
import PublicOrderingServices from "../services/PublicOrderingServices";
import OrderBill from "./OrderBill";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import StatusBadge from "../../../Components/Common/Badge";
import playBeep from "./PlayBeep";

// Default user logo SVG
const UserLogoPic = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Background circle */}
    <circle cx="60" cy="60" r="60" fill="#ff7900" opacity="0.1" />
    <circle
      cx="60"
      cy="60"
      r="55"
      fill="#fff"
      stroke="#ff7900"
      strokeWidth="2"
    />

    {/* Head */}
    <circle cx="60" cy="45" r="22" fill="#ff7900" />

    {/* Body */}
    <path
      d="M 45 68 Q 45 65 60 65 Q 75 65 75 68 L 75 95 Q 75 100 70 100 L 50 100 Q 45 100 45 95 Z"
      fill="#ff7900"
    />
  </svg>
);

const ProfilePage = () => {
  const navigate = useNavigate();
  const { orgcode } = useParams();
  const [activeTab, setActiveTab] = useState("orders");
  // const [customerInfo, setCustomerInfo] = useState(null);
  const [orders, setOrders] = useState([]);
  console.log("🚀 ~ ProfilePage ~ orders:", orders);

  const location = useLocation();
  const { orgData } = location.state || {};
  console.log("🚀 ~ ProfilePage ~ orgData:", orgData);
  const customerInfoRaw = localStorage.getItem("CustomerInfo");
  const customerInfo = customerInfoRaw ? JSON.parse(customerInfoRaw) : null;
  console.log("🚀 ~ ProfilePage ~ customerInfo:", customerInfo);
  const [billOpen, setBillOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [billLoading, setBillLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(() => {
    const saved = localStorage.getItem("isSoundOn");
    return saved !== null ? JSON.parse(saved) : true; // default ON
  });
  // Add these states in your component where orders state exists
  const [activeFilter, setActiveFilter] = useState("All");
  const [loadingOrderId, setLoadingOrderId] = useState(null); // Track which order is loading

  // Password change modal states
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  // Add this filter logic
  const filterOptions = ["All", "Ongoing", "Completed", "Cancelled"];

  const filteredOrders = orders.filter((order) => {
    if (activeFilter === "All") return true;
    return order.orderStatus === activeFilter;
  });

  // Modify your openBill function to handle loading state
  const handleOpenBill = async (order) => {
    setLoadingOrderId(order.orderRefrenceId);
    playBeep();
    await openBill(order);
    setLoadingOrderId(null);
  };

  const openBill = async (order) => {
    console.log("🚀 ~ openBill ~ order:", order);
    try {
      setBillLoading(true);

      const detail = await PublicOrderingServices.getCustomerOrderDetail({
        token: customerInfo.accessToken,
        apikey: orgcode,
        orderRefNumber: order.orderRefrenceId, // ✅ important
      });

      console.log("✅ Order Detail:", detail);

      setSelectedOrder({
        ...order, // keep old data
        detail: detail, // attach API response
      });

      setBillOpen(true);
    } catch (error) {
      console.error("❌ Failed to fetch order detail:", error);
      alert("Failed to load order details");
    } finally {
      setBillLoading(false);
    }
  };

  const closeBill = () => setBillOpen(false);

  // useEffect(() => {
  //   try {
  //     const customerData = localStorage.getItem("CustomerInfo");
  //     if (customerData) {
  //       setCustomerInfo(JSON.parse(customerData));
  //     }

  //     const placedOrders = localStorage.getItem("placedOrders");
  //     if (placedOrders) {
  //       const parsedOrders = JSON.parse(placedOrders);
  //       setOrders(Array.isArray(parsedOrders) ? parsedOrders : []);
  //     }
  //   } catch (err) {
  //     console.error("Error loading profile data:", err);
  //   }
  // }, []);

  const handleLogout = () => {
    localStorage.removeItem("CustomerInfo");
    localStorage.removeItem("publicCartV2");
    localStorage.removeItem("customerToken");
    localStorage.removeItem("pendingOrder");
    navigate(`/${orgcode}`);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordSuccess("");

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordError("New password and confirm password do not match");
      return;
    }

    if (passwordForm.newPassword.length < 6) {
      setPasswordError("New password must be at least 6 characters long");
      return;
    }

    try {
      setPasswordLoading(true);
      await PublicOrderingServices.changePassword({
        token: token,
        oldPassword: passwordForm.oldPassword,
        newPassword: passwordForm.newPassword,
        confirmPassword: passwordForm.confirmPassword,
      });

      setPasswordSuccess("Password changed successfully!");
      setPasswordForm({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setTimeout(() => {
        setPasswordModal(false);
        setPasswordSuccess("");
      }, 2000);
    } catch (error) {
      console.error("Password change error:", error);
      setPasswordError(
        error?.message || "Failed to change password. Please try again."
      );
    } finally {
      setPasswordLoading(false);
    }
  };

  const user = customerInfo?.user || {};

  const token = customerInfo?.accessToken;
  console.log("🚀 ~ ProfilePage ~ token:", token);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await PublicOrderingServices.getCustomerOrders({
          token: token,
          apikey: orgData?.orgCode,
        });
        console.log("🚀 ~ fetchOrders ~ res:", res);

        setOrders(res.items || []);
      } catch (err) {
        console.error("Order Fetch Error:", err);
      }
    };

    fetchOrders();
  }, []);

  useEffect(() => {
    localStorage.setItem("isSoundOn", JSON.stringify(isEnabled));
  }, [isEnabled]);

  return (
    <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <Container className="py-4" style={{ maxWidth: "1200px" }}>
        <div className="sticky-top">
          <Header orgData={orgData} />
        </div>

        {/* Tabs Section */}
        <Row>
          <Col md={{ size: 12 }}>
            <Card
              style={{
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                border: "none",
                borderRadius: "12px",
              }}
            >
              <CardBody>
                {/* Tab Navigation */}
                <Nav
                  tabs
                  style={{
                    borderBottom: "2px solid #f0f0f0",
                    display: "flex",
                    justifyContent: "space-between", // equal spacing between tabs
                    width: "100%", // full width
                  }}
                >
                  <NavItem style={{ flex: 1, textAlign: "center" }}>
                    <NavLink
                      className={classnames({ active: activeTab === "orders" })}
                      onClick={() => {
                        playBeep();
                        setActiveTab("orders");
                      }}
                      style={{
                        cursor: "pointer",
                        borderRadius: "8px 8px 0 0",
                        color: activeTab === "orders" ? "#ff7900" : "#666",
                        fontWeight: activeTab === "orders" ? "700" : "500",
                        borderBottom:
                          activeTab === "orders" ? "3px solid #ff7900" : "none",
                      }}
                    >
                      <i className="bx bx-shopping-bag me-2" />
                      <span className="d-none d-md-inline ms-2">
                        Order History{" "}
                      </span>
                      ({orders.length})
                    </NavLink>
                  </NavItem>

                  <NavItem style={{ flex: 1, textAlign: "center" }}>
                    <NavLink
                      className={classnames({
                        active: activeTab === "profile",
                      })}
                      onClick={() => {
                        playBeep();
                        setActiveTab("profile");
                      }}
                      style={{
                        cursor: "pointer",
                        borderRadius: "8px 8px 0 0",
                        color: activeTab === "profile" ? "#ff7900" : "#666",
                        fontWeight: activeTab === "profile" ? "700" : "500",
                        borderBottom:
                          activeTab === "profile"
                            ? "3px solid #ff7900"
                            : "none",
                      }}
                    >
                      <i className="bx bx-user me-2" />
                      <span className="d-none d-md-inline ms-2">
                        Profile Info
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ flex: 1, textAlign: "center" }}>
                    <NavLink
                      className={classnames({
                        active: activeTab === "settings",
                      })}
                      onClick={() => {
                        playBeep();
                        setActiveTab("settings");
                      }}
                      style={{
                        cursor: "pointer",
                        borderRadius: "8px 8px 0 0",
                        color: activeTab === "settings" ? "#ff7900" : "#666",
                        fontWeight: activeTab === "settings" ? "700" : "500",
                        borderBottom:
                          activeTab === "settings"
                            ? "3px solid #ff7900"
                            : "none",
                      }}
                    >
                      <i className="bx bx-cog me-2" />
                      <span className="d-none d-md-inline ms-2">Settings</span>
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent
                  activeTab={activeTab}
                  style={{ paddingTop: "20px" }}
                >
                  {/* Profile Info Tab */}
                  <TabPane tabId="profile">
                    <Row>
                      <Col md="8">
                        <div
                          style={{
                            backgroundColor: "#f9fafb",
                            borderRadius: "10px",
                            padding: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <h5 className="fw-bold mb-4">Personal Information</h5>

                          <div className="mb-4">
                            <div style={{ marginBottom: "8px" }}>
                              <strong style={{ color: "#2c3e50" }}>
                                Full Name
                              </strong>
                            </div>
                            <div
                              style={{
                                padding: "10px 12px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                color: "#666",
                              }}
                            >
                              {user?.username || "N/A"}
                            </div>
                          </div>

                          <div className="mb-4">
                            <div style={{ marginBottom: "8px" }}>
                              <strong style={{ color: "#2c3e50" }}>
                                Email Address
                              </strong>
                            </div>
                            <div
                              style={{
                                padding: "10px 12px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                color: "#666",
                              }}
                            >
                              {user?.email || "N/A"}
                            </div>
                          </div>

                          <div className="mb-4">
                            <div style={{ marginBottom: "8px" }}>
                              <strong style={{ color: "#2c3e50" }}>
                                Phone Number
                              </strong>
                            </div>
                            <div
                              style={{
                                padding: "10px 12px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                color: "#666",
                              }}
                            >
                              {user?.phoneNumber || "N/A"}
                            </div>
                          </div>

                          <div>
                            <div style={{ marginBottom: "8px" }}>
                              <strong style={{ color: "#2c3e50" }}>
                                Account Status
                              </strong>
                            </div>
                            <div
                              style={{
                                padding: "10px 12px",
                                backgroundColor: "#d4edda",
                                borderRadius: "8px",
                                border: "1px solid #c3e6cb",
                                color: "#155724",
                                fontWeight: "600",
                              }}
                            >
                              <i className="bx bx-check-circle me-2" />
                              Active
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>

                  {/* Order History Tab */}
                  <TabPane tabId="orders">
                    <div style={{ padding: "12px" }}>
                      {/* Header */}
                      <div
                        style={{
                          marginBottom: "16px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <div>
                          <h5
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#1a1a1a",
                              marginBottom: "2px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <i
                              className="bx bx-receipt"
                              style={{ color: "#ff7900", fontSize: "20px" }}
                            />
                            Order History
                          </h5>
                          <p
                            style={{
                              color: "#999",
                              fontSize: "12px",
                              margin: 0,
                            }}
                          >
                            {filteredOrders.length}{" "}
                            {filteredOrders.length === 1 ? "order" : "orders"}
                          </p>
                        </div>
                      </div>

                      {/* Filter Chips */}
                      <div
                        style={{
                          marginBottom: "16px",
                          display: "flex",
                          gap: "6px",
                          overflowX: "auto",
                          paddingBottom: "4px",
                        }}
                      >
                        {filterOptions.map((filter) => (
                          <button
                            key={filter}
                            onClick={() => setActiveFilter(filter)}
                            style={{
                              padding: "6px 16px",
                              border:
                                activeFilter === filter
                                  ? "2px solid #ff7900"
                                  : "1px solid #ddd",
                              borderRadius: "20px",
                              background:
                                activeFilter === filter ? "#fff5ed" : "white",
                              color:
                                activeFilter === filter ? "#ff7900" : "#666",
                              fontSize: "12px",
                              fontWeight:
                                activeFilter === filter ? "600" : "500",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {filter}
                          </button>
                        ))}
                      </div>

                      {/* Orders List */}
                      {filteredOrders.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px 20px",
                            background: "#fafafa",
                            borderRadius: "10px",
                            border: "1px dashed #ddd",
                          }}
                        >
                          <i
                            className="bx bx-box"
                            style={{
                              fontSize: "48px",
                              display: "block",
                              marginBottom: "12px",
                              color: "#ddd",
                            }}
                          />
                          <p
                            style={{
                              color: "#999",
                              fontSize: "13px",
                              marginBottom: "16px",
                            }}
                          >
                            {activeFilter === "All"
                              ? "No orders yet"
                              : `No ${activeFilter.toLowerCase()} orders`}
                          </p>
                          <Button
                            color="danger"
                            size="sm"
                            style={{
                              backgroundColor: "#ff7900",
                              border: "none",
                              borderRadius: "6px",
                              padding: "8px 20px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                            onClick={() => {
                              playBeep();
                              navigate(`/${orgcode}`);
                            }}
                          >
                            <i className="bx bx-cart-add me-1" />
                            Start Ordering
                          </Button>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          {filteredOrders.map((order, idx) => (
                            <Card
                              key={idx}
                              style={{
                                border: "1px solid #e8e8e8",
                                borderRadius: "10px",
                                overflow: "hidden",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                              }}
                            >
                              <CardBody style={{ padding: "14px" }}>
                                {/* Header Row - Order ID and Status */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                    paddingBottom: "10px",
                                    borderBottom: "1px solid #f0f0f0",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {/* Order Reference */}
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#1a1a1a",
                                      }}
                                    >
                                      {order.orderRefrenceId}
                                    </div>

                                    {/* View Details Pill Button */}
                                    <Button
                                      size="sm"
                                      disabled={
                                        loadingOrderId === order.orderRefrenceId
                                      }
                                      onClick={() => handleOpenBill(order)}
                                      style={{
                                        borderRadius: "20px",
                                        padding: "4px 12px",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        border: "1px solid #ff7900",
                                        background:
                                          loadingOrderId ===
                                          order.orderRefrenceId
                                            ? "#ff7900"
                                            : "white",
                                        color:
                                          loadingOrderId ===
                                          order.orderRefrenceId
                                            ? "white"
                                            : "#ff7900",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                      }}
                                    >
                                      {loadingOrderId ===
                                      order.orderRefrenceId ? (
                                        <>
                                          <i className="bx bx-loader-alt bx-spin" />
                                          Loading
                                        </>
                                      ) : (
                                        <>
                                          <i className="bx bx-show" />
                                          View
                                        </>
                                      )}
                                    </Button>

                                    {/* Payment Pill */}
                                    {/* <Button
  size="sm"
  disabled={
    loadingOrderId === order.orderRefrenceId ||
    order.orderStatus === "Cancelled" ||
    order.paymentStatus === "Paid"
  }
  onClick={() => handleOpenBill(order)}
  style={{
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "11px",
    fontWeight: "600",
    border: "1px solid",
    borderColor:
      order.orderStatus === "Cancelled" || order.paymentStatus === "Paid"
        ? "#ccc"
        : "#ff7900",
    background:
      loadingOrderId === order.orderRefrenceId
        ? "#ff7900"
        : order.orderStatus === "Cancelled" || order.paymentStatus === "Paid"
        ? "#f5f5f5"
        : "white",
    color:
      loadingOrderId === order.orderRefrenceId
        ? "white"
        : order.orderStatus === "Cancelled" || order.paymentStatus === "Paid"
        ? "#999"
        : "#ff7900",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor:
      order.orderStatus === "Cancelled" || order.paymentStatus === "Paid"
        ? "not-allowed"
        : "pointer",
  }}
>
  {loadingOrderId === order.orderRefrenceId ? (
    <>
      <i className="bx bx-loader-alt bx-spin" />
      Processing
    </>
  ) : order.paymentStatus === "Paid" ? (
    <>
      <i className="bx bx-check-circle" />
      Paid
    </>
  ) : order.orderStatus === "Cancelled" ? (
    <>
      <i className="bx bx-x-circle" />
      Cancelled
    </>
  ) : (
    <>
      <i className="bx bx-credit-card" />
      Pay
    </>
  )}
</Button> */}
                                  </div>

                                  <StatusBadge
                                    status={order.orderStatus}
                                    type="order"
                                    pill="true"
                                  />
                                </div>

                                {/* Details Row */}
                                <Row className="g-2 mb-2">
                                  <Col xs="4">
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#999",
                                        marginBottom: "3px",
                                        textTransform: "uppercase",
                                        fontWeight: "500",
                                        letterSpacing: "0.3px",
                                      }}
                                    >
                                      Payment
                                    </div>
                                    <StatusBadge
                                      status={order.paymentStatus}
                                      type="payment"
                                      pill="true"
                                    />
                                  </Col>

                                  <Col xs="4">
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#999",
                                        marginBottom: "3px",
                                        textTransform: "uppercase",
                                        fontWeight: "500",
                                        letterSpacing: "0.3px",
                                      }}
                                    >
                                      Total
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        color: "#1a1a1a",
                                      }}
                                    >
                                      Rs.{" "}
                                      <NumberWithCommas
                                        number={order.grandTotal}
                                      />
                                    </div>
                                  </Col>

                                  <Col xs="4">
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#999",
                                        marginBottom: "3px",
                                        textTransform: "uppercase",
                                        fontWeight: "500",
                                        letterSpacing: "0.3px",
                                      }}
                                    >
                                      Discount
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        color:
                                          order.discountAmount > 0
                                            ? "#28a745"
                                            : "#999",
                                      }}
                                    >
                                      Rs.{" "}
                                      <NumberWithCommas
                                        number={order.discountAmount}
                                      />
                                    </div>
                                  </Col>
                                </Row>

                                {/* Action Button - Centered with Max Width */}
                                {/* <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "8px",
                                  }}
                                >
                                  <Button
                                    size="sm"
                                    style={{
                                      maxWidth: "250px",
                                      width: "100%",
                                      padding: "8px 16px",
                                      borderRadius: "6px",
                                      fontWeight: "500",
                                      fontSize: "12px",
                                      border: "1px solid #ff7900",
                                      color: "#ff7900",
                                      background: "white",
                                      transition: "all 0.2s ease",
                                    }}
                                    disabled={
                                      loadingOrderId === order.orderRefrenceId
                                    }
                                    onClick={() => handleOpenBill(order)}
                                    onMouseEnter={(e) => {
                                      if (
                                        loadingOrderId !== order.orderRefrenceId
                                      ) {
                                        e.currentTarget.style.background =
                                          "#ff7900";
                                        e.currentTarget.style.color = "white";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (
                                        loadingOrderId !== order.orderRefrenceId
                                      ) {
                                        e.currentTarget.style.background =
                                          "white";
                                        e.currentTarget.style.color = "#ff7900";
                                      }
                                    }}
                                  >
                                    {loadingOrderId ===
                                    order.orderRefrenceId ? (
                                      <>
                                        <i className="bx bx-loader-alt bx-spin me-1" />
                                        Loading...
                                      </>
                                    ) : (
                                      <>
                                        <i className="bx bx-show me-1" />
                                        View Details
                                      </>
                                    )}
                                  </Button>
                                </div> */}
                              </CardBody>
                            </Card>
                          ))}
                        </div>
                      )}
                    </div>
                  </TabPane>
                  {/* Settings Tab */}
                  <TabPane tabId="settings">
                    <Row>
                      <Col md="8">
                        <div
                          style={{
                            backgroundColor: "#f9fafb",
                            borderRadius: "10px",
                            padding: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <h5 className="fw-bold mb-4">
                            <i className="bx bx-lock me-2" />
                            Security Settings
                          </h5>

                          <div className="mb-3">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "12px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <div>
                                <strong>Change Password</strong>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#999",
                                    marginTop: "4px",
                                  }}
                                >
                                  Update your password regularly for security
                                </div>
                              </div>
                              <Button
                                size="sm"
                                color="outline-secondary"
                                style={{ borderRadius: "6px" }}
                                onClick={() => {
                                  playBeep();
                                  setPasswordModal(true);
                                }}
                              >
                                Update
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col md="4">
                        <div
                          style={{
                            backgroundColor: "#f9fafb",
                            borderRadius: "10px",
                            padding: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <h5 className="fw-bold mb-4">
                            <i className="bx bx-lock me-2" />
                            Feature Settings
                          </h5>

                          <div className="mb-3">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "12px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <div>
                                <strong>Sound On</strong>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#999",
                                    marginTop: "4px",
                                  }}
                                >
                                  Sound can be toggle on off.
                                </div>
                              </div>
                              <Button
                                size="sm"
                                color={isEnabled ? "success" : "secondary"}
                                style={{
                                  borderRadius: "6px",
                                  minWidth: "70px",
                                }}
                                onClick={() => {
                                  const newValue = !isEnabled;
                                  setIsEnabled(newValue);
                                  localStorage.setItem(
                                    "isSoundOn",
                                    JSON.stringify(newValue)
                                  );

                                  // 🔄 refresh page
                                  window.location.reload();
                                }}
                              >
                                {isEnabled ? "ON" : "OFF"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>

                      {/* <Col md="4">
                        <div
                          style={{
                            backgroundColor: "#ffe5e5",
                            borderRadius: "10px",
                            padding: "16px",
                            border: "1px solid #ffcccc",
                          }}
                        >
                          <h6 className="fw-bold mb-3">
                            <i className="bx bx-trash me-2" />
                            Danger Zone
                          </h6>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#666",
                              marginBottom: "12px",
                            }}
                          >
                            Be careful with these actions. They cannot be
                            undone.
                          </p>
                          <Button
                            color="danger"
                            size="sm"
                            style={{
                              width: "100%",
                              backgroundColor: "#dc3545",
                              border: "none",
                              borderRadius: "6px",
                            }}
                          >
                            <i className="bx bx-trash me-2" />
                            Delete Account
                          </Button>
                        </div>
                      </Col> */}
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <OrderBill
        isOpen={billOpen}
        toggle={closeBill}
        selectedOrder={selectedOrder?.detail}
        // order={selectedOrder.detail}
      />

      {/* Password Change Modal */}
      <Modal
        isOpen={passwordModal}
        toggle={() => {
          setPasswordModal(!passwordModal);
          setPasswordError("");
          setPasswordSuccess("");
          setPasswordForm({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }}
        centered
      >
        <ModalHeader toggle={() => setPasswordModal(!passwordModal)}>
          <i className="bx bx-lock me-2" />
          Change Password
        </ModalHeader>
        <Form onSubmit={handlePasswordChange}>
          <ModalBody>
            {passwordError && (
              <Alert color="danger" className="mb-3">
                <i className="bx bx-error-circle me-2" />
                {passwordError}
              </Alert>
            )}
            {passwordSuccess && (
              <Alert color="success" className="mb-3">
                <i className="bx bx-check-circle me-2" />
                {passwordSuccess}
              </Alert>
            )}

            <FormGroup>
              <Label for="oldPassword">
                Current Password <span className="text-danger">*</span>
              </Label>
              <Input
                type="password"
                id="oldPassword"
                placeholder="Enter your current password"
                value={passwordForm.oldPassword}
                onChange={(e) =>
                  setPasswordForm({
                    ...passwordForm,
                    oldPassword: e.target.value,
                  })
                }
                required
              />
            </FormGroup>

            <FormGroup>
              <Label for="newPassword">
                New Password <span className="text-danger">*</span>
              </Label>
              <Input
                type="password"
                id="newPassword"
                placeholder="Enter your new password"
                value={passwordForm.newPassword}
                onChange={(e) =>
                  setPasswordForm({
                    ...passwordForm,
                    newPassword: e.target.value,
                  })
                }
                required
              />
            </FormGroup>

            <FormGroup>
              <Label for="confirmPassword">
                Confirm New Password <span className="text-danger">*</span>
              </Label>
              <Input
                type="password"
                id="confirmPassword"
                placeholder="Confirm your new password"
                value={passwordForm.confirmPassword}
                onChange={(e) =>
                  setPasswordForm({
                    ...passwordForm,
                    confirmPassword: e.target.value,
                  })
                }
                required
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setPasswordModal(false)}
              disabled={passwordLoading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              type="submit"
              disabled={passwordLoading}
              style={{ backgroundColor: "#ff7900", borderColor: "#ff7900" }}
            >
              {passwordLoading ? (
                <>
                  <i className="bx bx-loader-alt bx-spin me-2" />
                  Changing...
                </>
              ) : (
                <>
                  <i className="bx bx-check me-2" />
                  Change Password
                </>
              )}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ProfilePage;
